(ns practitest.frontend.forms3.run.subs
  (:require
    [practitest.frontend.components2.run-status :as run-status]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::parent-instance
  (fn [db _]
    (get-in db [:entity :run :parent-instance])))

(re-frame/reg-sub
  ::parent-testset
  (fn [db _]
    (get-in db [:entity :run :parent-testset])))

(re-frame/reg-sub
  ::parent-test
  (fn [db _]
    (get-in db [:entity :run :parent-test])))

(re-frame/reg-sub
  ::navigation-data
  (fn [db _]
    (get-in db [:entity :run :navigation])))

(re-frame/reg-sub
  ::elapsed
  (fn [db _]
    (get-in db [:entity :run :timer :elapsed] 0)))

(re-frame/reg-sub
  ::running?
  (fn [db _]
    (get-in db [:entity :run :timer :running?] false)))

(re-frame/reg-sub
  ::time-management-enabled?
  :<- [::subs/current-project]
  (fn [project _]
    (:time_management_support project false)))

(re-frame/reg-sub
  ::timer-idle-minutes
  :<- [::subs/current-project]
  (fn [project _]
    (:timer_idle_time project 60)))

(re-frame/reg-sub
  ::steps-loading?
  (fn [db _]
    (get-in db [:entity :run :steps :loading?] false)))

(re-frame/reg-sub
  ::preconditions
  (fn [db _]
    (get-in db [:entity :run :preconditions :value])))

(re-frame/reg-sub
  ::preconditions-editing?
  (fn [db _]
    (get-in db [:entity :run :preconditions :editing?] false)))

(re-frame/reg-sub
  ::preconditions-draft
  (fn [db _]
    (get-in db [:entity :run :preconditions :draft])))

(re-frame/reg-sub
  ::preconditions-saving?
  (fn [db _]
    (get-in db [:entity :run :preconditions :saving?] false)))

(re-frame/reg-sub
  ::step-runs
  (fn [db _]
    (get-in db [:entity :run :steps :step-runs])))

(re-frame/reg-sub
  ::steps-dirty?
  (fn [db _]
    (get-in db [:entity :run :steps :dirty?] false)))

(re-frame/reg-sub
  ::has-non-called-dirty?
  (fn [db _]
    (get-in db [:entity :run :steps :has-non-called-dirty?] false)))

;; A step open for editing has an unsaved draft that hasn't reached the
;; backend yet, so "Update Test" must still be enabled for it - it'll flush
;; the draft first (see ::run-events/flush-then-sync) - as long as the step
;; isn't a called step, which can't be synced back to its own originating test.
(re-frame/reg-sub
  ::has-editing-non-called?
  (fn [db _]
    (let [editing-ids (get-in db [:entity :run :steps :editing-step-ids] #{})
          step-runs   (get-in db [:entity :run :steps :step-runs])]
      (boolean (some (fn [step]
                       (and (contains? editing-ids (:id step))
                            (not (get-in step [:attributes :call-to-test-id]))))
                     step-runs)))))

(re-frame/reg-sub
  ::can-sync?
  :<- [::has-non-called-dirty?]
  :<- [::has-editing-non-called?]
  :<- [::preconditions-editing?]
  (fn [[dirty? editing? pre-editing?] _]
    (or dirty? editing? pre-editing?)))

;; Editing state is tracked per-step (a set of step-ids currently being
;; edited). This sub keeps the same "is any step being edited" boolean
;; semantics external callers (run.cljs, steps-dirty-or-editing?) already rely
;; on - also true while Preconditions is being edited, so navigating away with
;; an unsaved Preconditions draft triggers the same beforeunload warning.
(re-frame/reg-sub
  ::step-editing?
  (fn [db _]
    (boolean (or (seq (get-in db [:entity :run :steps :editing-step-ids]))
                 (get-in db [:entity :run :preconditions :editing?])))))

(re-frame/reg-sub
  ::step-saving?
  (fn [db [_ step-id]]
    (contains? (get-in db [:entity :run :steps :saving-step-ids] #{}) step-id)))

(re-frame/reg-sub
  ::step-being-edited?
  (fn [db [_ step-id]]
    (contains? (get-in db [:entity :run :steps :editing-step-ids] #{}) step-id)))

(re-frame/reg-sub
  ::step-draft
  (fn [db [_ step-id]]
    (get-in db [:entity :run :steps :drafts step-id])))

(re-frame/reg-sub
  ::steps-dirty-or-editing?
  :<- [::steps-dirty?]
  :<- [::step-editing?]
  (fn [[dirty? editing?] _]
    (or dirty? editing?)))

(re-frame/reg-sub
  ::steps-dirty-fields
  :<- [::steps-dirty-or-editing?]
  (fn [dirty-or-editing? _]
    (if dirty-or-editing? [:dirty] [])))

(re-frame/reg-sub
  ::pending-edit-step-id
  (fn [db _]
    (get-in db [:entity :run :steps :pending-edit-id])))

(re-frame/reg-sub
  ::unsynced-warning
  (fn [db _]
    (get-in db [:entity :run :unsynced-warning])))

(re-frame/reg-sub
  ::link-issues-target-step-id
  (fn [db _]
    (get-in db [:entity :run :steps :link-issues-target-step])))

(re-frame/reg-sub
  ::link-issue-by-id-modal-open?
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-modal-open?] false)))

(re-frame/reg-sub
  ::link-issue-by-id-error
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-error])))

(re-frame/reg-sub
  ::azure-projects
  (fn [db _]
    (get-in db [:entity :run :steps :azure-projects] [])))

(re-frame/reg-sub
  ::azure-projects-loading?
  (fn [db _]
    (get-in db [:entity :run :steps :azure-projects-loading?] false)))

(re-frame/reg-sub
  ::link-issue-by-id-value
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-value] "")))

(re-frame/reg-sub
  ::link-issue-by-id-azure-project
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-azure-project])))

(re-frame/reg-sub
  ::link-issue-by-id-type
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-type] :external)))

(re-frame/reg-sub
  ::unlink-issue-confirm-target-id
  (fn [db _]
    (get-in db [:entity :run :steps :unlink-confirm-target-id])))

(re-frame/reg-sub
  ::next-undefined-step
  :<- [::step-runs]
  (fn [step-runs _]
    (first (filter #(= run-status/no-run-status (get-in % [:attributes :status])) step-runs))))

(re-frame/reg-sub
  ::run-attachments
  (fn [db _]
    (get-in db [:entity :run :attachments :data])))
